<template>
	<v-container fluid>
		<v-row>
			<v-col col="6">
				<v-card>
					<v-card-title class="text-h4 text--primary">
						Test av SIE-fil {{filename}}
						<v-spacer></v-spacer>
						<v-btn v-if="errors" @click="reset">
							Testa en ny fil
						</v-btn>

					</v-card-title>
				</v-card>
				<v-card>

					<v-card-text v-show="!errors">
						<p class="text--primary" v-show="!uploaded && !uploading">
							Här kan du ladda upp en fil för test. Testapplikationen genererar då en felrapport som listar upptäckta fel i filen.
						</p>
						<file-drop v-show="!uploaded && !uploading"
									  @uploaded="finishUploading($event)"
									  @uploading="startUploading"
									  @failed="uploadFailed" />

						<v-row v-if="uploading">
							<v-col align="center">
								<v-progress-circular indeterminate color="secondary" :size="70" />
							</v-col>
						</v-row>

						<v-row v-if="uploading">
							<v-col align="center" class="text-h4 text--primary">
								Uppdaddning av filen pågår.
							</v-col>
						</v-row>

						<v-row v-if="processing">
							<v-col align="center">
								<v-progress-circular indeterminate color="primary" :size="70" />
							</v-col>
						</v-row>

						<v-row v-if="processing">
							<v-col align="center" class="text-h4 text--primary">
								Filen analyseras på servern.
							</v-col>
						</v-row>

						<p class="text--primary" v-show="!uploaded && !uploading">
							Uppladdade SIE-filer sparas på servern endast under den tid testrutinerna körs, och raderas omedelbart därefter.
						</p>

					</v-card-text>
				</v-card>

				<v-card v-if="errors"
						  class="mt-5"
						  elevation="2">
					<v-card-title class="mb-0 pb-0">
						Sammanfattning
					</v-card-title>
					<v-card-text>
						<div v-for="(item, index) in errors.summaryErrors" class="mb-0">

							<div class="text-subtitle-2 text--primary mt-5" v-if="item.level === 'Header'">
								{{ item.text }}
							</div>
							<span class="text--primary" v-if="item.level === 'Info'">
								<v-icon color="blue">mdi-information</v-icon>
								{{ item.text }}
							</span>
							<span class="text--primary" v-if="item.level === 'Pass'">
								<v-icon color="green">mdi-check</v-icon>
								{{ item.text }}
							</span>
							<span class="text--primary" v-if="item.level === 'Warning'">
								<v-icon color="orange">mdi-alert</v-icon>
								{{ item.text }}
							</span>
							<span class="text--primary" v-if="item.level === 'Semi'">
								<v-icon color="red">mdi-clipboard-alert</v-icon>
								{{ item.text }}
							</span>
							<span class="text--primary" v-if="item.level === 'Error'">
								<v-icon color="red">mdi-alert-octagon</v-icon>
								{{ item.text }}
							</span>
						</div>
					</v-card-text>
				</v-card>

				<v-card class="mt-5" elevation="2" v-if="errors">
					<div v-for="(item, index) in errors.lineErrors">

						<div v-if="item.level === 'Code'" class="code-background">
							<div class="pa-0 ma-0 px-1 sie-code sie-code-line">{{ item.line }}</div>
							<div class="pa-0 ma-0 pl-1 sie-code">{{ item.text }}</div>
						</div>
						<div v-if="item.level === 'CodeRed'" class="code-background">
							<div class="pa-0 ma-0 px-1 sie-code sie-code-line">{{ item.line }}</div>
							<div class="pa-0 ma-0 pl-1 sie-code" v-html="item.text"></div>
						</div>
						<div v-if="item.level === 'CodeBefore'" class="code-background">
							<div class="pa-0 ma-0 pl-1 sie-code-before">&nbsp;</div>
						</div>
						<div v-if="item.level === 'CodeAfter'" class="code-background">
							<div class="pa-0 ma-0 pl-1 sie-code-after">&nbsp;</div>
						</div>

						<span v-if="item.level === 'Info'">
							<v-icon color="blue">mdi-information</v-icon>
							{{ item.text }}
						</span>
						<span v-if="item.level === 'Pass'">
							<v-icon color="green">mdi-check</v-icon>
							{{ item.text }}
						</span>
						<span v-if="item.level === 'Warning'">
							<v-icon color="orange">mdi-alert</v-icon>
							{{ item.text }}
						</span>
						<span v-if="item.level === 'Semi'">
							<v-icon color="red">mdi-clipboard-alert</v-icon>
							{{ item.text }}
						</span>
						<span v-if="item.level === 'Error'">
							<v-card-subtitle class="text-subtitle-2 py-2">
								<v-icon color="red">mdi-alert-octagon</v-icon>
								{{ item.text }}
							</v-card-subtitle>
						</span>
					</div>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import config from 'config';
	import FileDrop from '../components/FileDrop.vue';
	import axios from "axios";
	import * as Sentry from '@sentry/vue';

	export default {
		name: 'Home',
		components: {
			FileDrop
		},
		data() {
			return {
				dragAndDropCapable: false,
				files: [],
				uploading: false,
				uploaded: false,
				processing: false,

				uploadPercentage: 0,

				timer: null,
				timerCount: 0,
				jobId: null,
				errors: null,
				filename: ""
			}
		},
		mounted() {
		},
		methods: {

			reset() {
				this.uploading = false;
				this.uploaded = false;
				this.processing = false;

				this.errors = null;
			},

			startUploading() {
				//console.log('uploading: ');
				this.uploading = true;
			},
			finishUploading(response) {
				console.log('finishUploading: ' + response.testjobId);
				this.jobId = response.testjobId;
				this.uploaded = true;
				this.uploading = false;
				this.processing = true;
				this.timer = setInterval(this.timerTick, 500);
				this.timerCount = 0;
			},
			uploadFailed(response) {
				console.log('Upload failed: ');
				console.log(response);
				this.setErrorState(response);
			},
			timerTick() {
				this.timerCount++;

				if (this.timerCount > 60) {
					// Job seems hung
					clearInterval(this.timer);
					Sentry.captureMessage("Testjobbet tar för lång tid");
					this.setErrorState("Testjobbet tog för lång tid");
					return;
				}

				if (this.timerTickActive) {
					console.log("Timer overrun");
					return;
				}

				this.timerTickActive = true;

				axios.get(`${config.apiUrl}/status/${this.jobId}`,
					{
						timeout: 20000,
						headers: {
							'Accept': 'application/json',
						}
					}
				).then((response) => {
					if (response.data.finished) {
						clearInterval(this.timer);
						this.processing = false;
						this.errors = response.data.errors;
					}
					this.timerTickActive = false;
				})
					.catch((error) => {
						Sentry.captureException(error);

						this.timerTickActive = false;
						clearInterval(this.timer);
						this.processing = false;

						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range of 2xx

							var msg = 'Request to ' + error.response.config.url + ' failed with status code ' + error.response.status + " - " + error.response.statusText;
							//console.log(msg);
							this.setErrorState(msg);
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js

							this.setErrorState('No response');
						} else {
							// Something happened in setting up the request that triggered an Error

							this.setErrorState(error.message);
						}
					});
			},
			setErrorState(message) {
				this.processing = false;
				this.errors =
				{
					"summaryErrors": [
						{
							"text": "Fel i kommunikationen med testservern",
							"code": 0,
							"level": "Header"
						},
						{
							"text": message,
							"code": 0,
							"level": "Error"
						}
					],
					"lineErrors": [],
					"errorsFound": true,
					"warningsFound": false,
					"ovreallStatus": 2
				}
			},

		}
	}
</script>

<style>
</style>